export default class Address {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        addressRetrieve(id: ${id}) {
          id
          street
          unit
          houseNumber
          postCode
          latitude
          longitude
          city {
            id
            name
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.addressRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        addressList {
          results {
            id
            street
            unit
            houseNumber
            postCode
            latitude
            longitude
            city {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.addressList.results.reverse();
  }

  static async filter(axios, city) {
    const response = await axios.post(
      '/graphql/',
      `query{
        addressList (city: ${city}) {
          results {
            id
            street
            unit
            houseNumber
            postCode
            latitude
            longitude
            city {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.addressList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteAddress(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteAddress.ok;
  }

  static async create(axios, street, unit, houseNumber, postCode, latitude, longitude, city) {
    const cityField = (city > 0) ? `city: ${city},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        createAddress(newAddress: {
          ${cityField}
          street: "${street}", 
          unit: "${unit}", 
          houseNumber: "${houseNumber}", 
          postCode: "${postCode}", 
          latitude: "${latitude}", 
          longitude: "${longitude}", 
        }) {
          ok
          address {
            id
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    if (response.data.data.createAddress.ok) {
      return response.data.data.createAddress.address.id
    } else {
      return response.data.data.createAddress.ok;
    }

  }


  static async edit(axios, id, street, unit, houseNumber, postCode, latitude, longitude, city) {
    const cityField = (city > 0) ? `city: ${city},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateAddress(newAddress: {
          ${cityField}
          id: ${id},
          street: "${street}", 
          unit: "${unit}", 
          houseNumber: "${houseNumber}", 
          postCode: "${postCode}", 
          latitude: "${latitude}", 
          longitude: "${longitude}", 
        }) {
          ok
          address {
            id
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    if (response.data.data.updateAddress.ok) {
      return response.data.data.updateAddress.address.id
    } else {
      return response.data.data.updateAddress.ok;
    }
  }


}